import { render } from "./ToastWidget.vue?vue&type=template&id=496c03cb&scoped=true"
import script from "./ToastWidget.vue?vue&type=script&lang=js"
export * from "./ToastWidget.vue?vue&type=script&lang=js"

import "./ToastWidget.vue?vue&type=style&index=0&id=496c03cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496c03cb"],['__file',"src/components/ToastWidget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "496c03cb"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('496c03cb', __exports__)) {
    api.reload('496c03cb', __exports__)
  }
  
  module.hot.accept("./ToastWidget.vue?vue&type=template&id=496c03cb&scoped=true", () => {
    api.rerender('496c03cb', render)
  })

}


export default __exports__